import React from "react";

function Benefits() {
    return (
        <section className="benefits section-padding">
            <div className="w-layout-blockcontainer container w-container">
                <div data-w-id="41803765-0c5a-d652-1079-7376a7674454"
                     className="content-wrapper benefit">
                    <div className="section-title center">
                        <p className="label">BENEFITS<br/></p>
                        <div className="title center">
                            <h2 className="heading-2 text-align-center">
                                The benefits of a having an AI-powered cloud based monitoring system
                            </h2>
                            <p className="section-subtitle center">
                                Experience the Future of the Internet with Secure and Transparent<br/>and
                                Decentralized Solutions
                            </p>
                        </div>
                    </div>
                    <div className="benefits-wrapper">
                        <div id="w-node-_131760e7-2676-f9e8-b1f2-60883f25fe40-2464a25d"
                             className="single-benefit stoke">
                            <div className="single-benefit-content-wrapper">
                                <img
                                    src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66dfd1619a524a3cb99fbfff_cube.png"
                                    loading="lazy" alt="" className="benefit-icon"/>
                                <div className="benefit-content">
                                    <div className="title">
                                        <p className="benefit-title">Predictive Insights & Anomaly Detection</p>
                                        <p className="body-text-16">
                                            AI algorithms can analyze large volumes of sensor data in real time, identifying
                                            subtle patterns or trends that might indicate early signs of failure, seepage,
                                            or instability—often before thresholds are breached. This allows for proactive
                                            intervention rather than reactive response.
                                        </p>
                                    </div>
                                    {/*<a data-w-id="85fa3048-1c51-3a58-6161-69ec7f34ce94" href="/company"*/}
                                    {/*   className="text-button w-inline-block">*/}
                                    {/*    <p className="body-text-16 text-neutral-01">*/}
                                    {/*        Learn More<br/>*/}
                                    {/*    </p>*/}
                                    {/*    <div className="button-icon-wrapper position-relative">*/}
                                    {/*        <img*/}
                                    {/*            src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66dfcf01a6aa088c35690345_arrow-down.svg"*/}
                                    {/*            loading="lazy" alt="" className="right-arrow posotion"/>*/}
                                    {/*        <img*/}
                                    {/*            src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66dfcf01a6aa088c35690345_arrow-down.svg"*/}
                                    {/*            loading="lazy" alt="" className="right-arrow"/>*/}
                                    {/*    </div>*/}
                                    {/*</a>*/}
                                </div>
                            </div>
                        </div>
                        <div id="w-node-_58e0c806-6159-b5d1-50f4-a7d14437d5b8-2464a25d"
                             className="single-benefit stoke">
                            <div className="single-benefit-content-wrapper">
                                <img
                                    src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66dfd161a9d8d8fe11d98a82_star.png"
                                    loading="lazy" alt="" className="benefit-icon"/>
                                <div className="benefit-content">
                                    <div className="title">
                                        <p className="benefit-title">Remote Access & Centralized Data Management</p>
                                        <p className="body-text-16">
                                            A cloud-based platform enables secure, real-time access to monitoring data from
                                            anywhere, allowing engineers, managers, and stakeholders to stay informed without
                                            being physically on site. All data is centralized, version-controlled, and easily
                                            accessible for analysis, reporting, or compliance.
                                        </p>
                                    </div>
                                    {/*<a data-w-id="85fa3048-1c51-3a58-6161-69ec7f34ce94" href="/company"*/}
                                    {/*   className="text-button w-inline-block">*/}
                                    {/*    <p className="body-text-16 text-neutral-01">*/}
                                    {/*        Learn More<br/>*/}
                                    {/*    </p>*/}
                                    {/*    <div className="button-icon-wrapper position-relative">*/}
                                    {/*        <img*/}
                                    {/*            src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66dfcf01a6aa088c35690345_arrow-down.svg"*/}
                                    {/*            loading="lazy" alt="" className="right-arrow posotion"/>*/}
                                    {/*        <img*/}
                                    {/*            src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66dfcf01a6aa088c35690345_arrow-down.svg"*/}
                                    {/*            loading="lazy" alt="" className="right-arrow"/>*/}
                                    {/*    </div>*/}
                                    {/*</a>*/}
                                </div>
                            </div>
                        </div>
                        <div id="w-node-_1a507c0b-8a15-ef19-c752-84deda74cbd4-2464a25d"
                             className="single-benefit stoke">
                            <div className="single-benefit-content-wrapper">
                                <img
                                    src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66dfd161ff8245616342d19b_sphere%20(2).png"
                                    loading="lazy" alt="" className="benefit-icon"/>
                                <div className="benefit-content">
                                    <div className="title">
                                        <p className="benefit-title">Automated Alerts & Intelligent Decision Support</p>
                                        <p className="body-text-16">
                                            AI can automatically trigger smart alerts, prioritize risks, and even suggest
                                            potential causes or mitigation actions based on historical trends and site-specific
                                            conditions. This enhances operational efficiency, reduces human error, and
                                            supports faster, data-driven decisions.
                                        </p>
                                    </div>
                                    {/*<a data-w-id="85fa3048-1c51-3a58-6161-69ec7f34ce94" href="/company"*/}
                                    {/*   className="text-button w-inline-block">*/}
                                    {/*    <p className="body-text-16 text-neutral-01">*/}
                                    {/*        Learn More<br/>*/}
                                    {/*    </p>*/}
                                    {/*    <div className="button-icon-wrapper position-relative">*/}
                                    {/*        <img*/}
                                    {/*            src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66dfcf01a6aa088c35690345_arrow-down.svg"*/}
                                    {/*            loading="lazy" alt="" className="right-arrow posotion"/>*/}
                                    {/*        <img*/}
                                    {/*            src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66dfcf01a6aa088c35690345_arrow-down.svg"*/}
                                    {/*            loading="lazy" alt="" className="right-arrow"/>*/}
                                    {/*    </div>*/}
                                    {/*</a>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Benefits;